import TmrBaseResource from './TmrBaseResource'

export default class Flaws extends TmrBaseResource {
  static endpoint = '/flaws'
}
